export default __webpack_public_path__ + "static/media/fi_info_payment.7210060c.svg";